<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_listing', 'sort_heading')"
    :side="'right'"
    :has-fixed-footer="true"
    @on-side-menu-close="$emit('onSortingMenuClose')"
  >
    <div class="h-full">
      <div
        class="bg-main flex flex-1 flex-col overflow-auto h-full py-24 px-16"
      >
        <div
          v-for="option in options"
          :key="'sorting-option' + option.key"
          class="pb-20 last:pb-0"
        >
          <CheckboxComponent
            :checked="option.key === activeOption"
            :highlight="true"
            :is-radio="true"
            :text="option.label"
            :input-name="'sorting-menu'"
            @on-check="onSort(option.key)"
          />
        </div>
      </div>
      <div
        class="absolute bg-picker flex pt-24 pr-24 pl-24 pb-32 right-0 bottom-0 left-0 z-30"
      >
        <ButtonComponent
          class="flex-1 ml-4"
          :text="$lang('product_listing', 'finish_filter_btn')"
          :is-block="true"
          :loading="loading"
          @click="closeSideMenu"
        />
      </div>
    </div>
  </SideMenu>
</template>

<script lang="ts">
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import CheckboxComponent from '~/components/forms/CheckboxComponent.vue';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';

import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    SideMenu,
    CheckboxComponent,
    ButtonComponent,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    activeOption: {
      type: String,
      required: false,
      default: 'byDate',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    closeSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.closeOverlay();
    },
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
    onSort(key: string) {
      this.$emit('onSort', key);
    },
  },
});
</script>
